import { useCallback, useEffect } from 'react';
import {
  addContactInfoField,
  removeContactInfoField,
  resetContactInfoFields,
  resetEditId,
  resetEditOptionType,
  resetOptionType,
  setContactInfoFields,
  setEditId,
  updateContactInfoField,
} from 'components/common/ContactFieldManager/contactFieldManagerSlice';
import { IContactFieldManager } from 'components/common/ContactFieldManager/index';
import { useAppDispatch } from 'store/hooks';
import { useTypedSelector } from 'store/store';
import { generateUniqueId } from 'utils/helpers';

export const useContactFieldManager = (props: IContactFieldManager) => {
  const { form, modalState, dataToEdit } = props;
  const contacts = useTypedSelector((state) => state.contactFieldManager.contactInfoFields);
  const editId = useTypedSelector((state) => state.contactFieldManager.editId);
  const dispatch = useAppDispatch();
  const onContactRowEdit = useCallback(
    (id: string) => {
      dispatch(setEditId(id));
    },
    [dispatch]
  );
  const onContactRowStateChange = useCallback(() => {
    dispatch(resetEditId());
  }, [dispatch]);

  const onContactRowCancel = useCallback(() => {
    form.resetFields();
  }, [form]);
  const onContactRowRemove = useCallback(
    (id: string) => {
      dispatch(removeContactInfoField(id));
    },
    [dispatch]
  );
  const onContactRowSave = useCallback(
    async (id?: string) => {
      try {
        await form.validateFields(id ? ['edit_type', 'edit_value'] : ['type', 'value']);
        const contactValue = form.getFieldsValue();
        if (id) {
          dispatch(
            updateContactInfoField({
              type: contactValue.edit_type,
              value: contactValue.edit_value,
              id,
            })
          );
          dispatch(resetEditOptionType());
        } else {
          dispatch(
            addContactInfoField({
              ...contactValue,
              id: generateUniqueId(),
            })
          );
          dispatch(resetOptionType());
        }
        dispatch(resetEditId());
        form.resetFields(id ? ['edit_type', 'edit_value'] : ['type', 'value']);
      } catch {
        return;
      }
    },
    [form, dispatch]
  );

  useEffect(() => {
    if (modalState) {
      if (dataToEdit?.length) {
        dispatch(setContactInfoFields(dataToEdit));
      } else {
        dispatch(resetContactInfoFields());
      }
    }
  }, [dataToEdit, modalState, dispatch]);

  return {
    editId,
    contacts,
    onContactRowEdit,
    onContactRowCancel,
    onContactRowRemove,
    onContactRowSave,
    onContactRowStateChange,
  };
};
